import { render, staticRenderFns } from "./feedback_table.vue?vue&type=template&id=34ae25c4&scoped=true"
import script from "./feedback_table.vue?vue&type=script&lang=ts"
export * from "./feedback_table.vue?vue&type=script&lang=ts"
import style0 from "./feedback_table.vue?vue&type=style&index=0&id=34ae25c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ae25c4",
  null
  
)

export default component.exports